import { RootState } from '../store'

export const authIsDeterminateSelector = (state: RootState) =>
  state.auth.isDeterminate

export const userSelector = (state: RootState) => state.auth.user

export const authIsAdminSelector = (state: RootState) => state.auth.isAdmin
